import { Button, Form, Spinner } from "react-bootstrap";
import { getTypeLabel, getTypeSelectValue } from "../../utils/ranking.utils";

const RankingsFilters = ({
  rallies = [],
  isRalliesLoading = false,
  selectedRallyId = "",
  onRallyChange,
  activeRallyId = "",
  types = [],
  isTypesLoading = false,
  selectedType = "",
  onTypeChange,
  categories = [],
  isCategoriesLoading = false,
  selectedCategory = "",
  onCategoryChange,
  stages = [],
  isStagesLoading = false,
  selectedStage = "",
  onStageChange,
  canManage = false,
  onAddRankings,
  onDeleteSnapshot,
  addDisabled = false,
  deleteDisabled = false,
  deleting = false,
}) => {
  return (
    <div className="d-flex flex-wrap align-items-end gap-3 mb-4">
      <Form.Group className="mb-0" style={{ minWidth: 220 }}>
        <Form.Label className="mb-1">Rally</Form.Label>
        <Form.Select
          value={selectedRallyId}
          onChange={(e) => onRallyChange(e.target.value)}
          disabled={isRalliesLoading}
        >
          <option value="">
            {isRalliesLoading ? "Loading rallies..." : "Select a rally"}
          </option>
          {rallies.map((rally) => {
            const id = rally._id || rally.id;
            const suffix =
              rally.isActive || id === activeRallyId ? " (Active)" : "";
            return (
              <option key={id} value={id}>
                {(rally.name || "Untitled rally") + suffix}
              </option>
            );
          })}
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-0" style={{ minWidth: 180 }}>
        <Form.Label className="mb-1">
          Type <span className="text-danger">*</span>
        </Form.Label>
        <Form.Select
          value={selectedType}
          onChange={(e) => onTypeChange(e.target.value)}
          disabled={!selectedRallyId || isTypesLoading}
        >
          <option value="">
            {isTypesLoading ? "Loading types..." : "Select a type"}
          </option>
          {types.map((type) => {
            const value = getTypeSelectValue(type);
            return (
              <option key={value} value={value}>
                {getTypeLabel(type)}
              </option>
            );
          })}
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-0" style={{ minWidth: 200 }}>
        <Form.Label className="mb-1">
          Category <span className="text-danger">*</span>
        </Form.Label>
        <Form.Select
          value={selectedCategory}
          onChange={(e) => onCategoryChange(e.target.value)}
          disabled={!selectedType || isCategoriesLoading}
        >
          <option value="">
            {!selectedType
              ? "Select a type first"
              : isCategoriesLoading
                ? "Loading categories..."
                : "Select a category"}
          </option>
          {categories.map((category) => {
            const key = category.key || category._id || category.id;
            return (
              <option key={key} value={category.key || key}>
                {category.title || category.key || "Untitled category"}
              </option>
            );
          })}
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-0" style={{ minWidth: 200 }}>
        <Form.Label className="mb-1">After stage (optional)</Form.Label>
        <Form.Select
          value={selectedStage}
          onChange={(e) => onStageChange(e.target.value)}
          disabled={!selectedRallyId || isStagesLoading}
        >
          <option value="">
            {isStagesLoading ? "Loading stages..." : "Latest snapshot"}
          </option>
          {stages.map((stage, index) => {
            const number =
              stage.stage_number ??
              stage.stageNumber ??
              stage.number ??
              index + 1;
            const name = stage.stage_name || stage.name || "";
            return (
              <option key={stage._id || stage.id || number} value={number}>
                {name ? `Stage ${number} — ${name}` : `Stage ${number}`}
              </option>
            );
          })}
        </Form.Select>
      </Form.Group>

      <div className="ms-auto d-flex align-items-center gap-2 flex-wrap">
        {(isRalliesLoading ||
          isTypesLoading ||
          isCategoriesLoading ||
          isStagesLoading) && <Spinner animation="border" size="sm" />}
        {/* Delete snapshot hidden for now
        {canManage && onDeleteSnapshot ? (
          <Button
            type="button"
            variant="outline-danger"
            onClick={onDeleteSnapshot}
            disabled={deleteDisabled || deleting}
          >
            {deleting ? "Deleting..." : "Delete snapshot"}
          </Button>
        ) : null}
        */}
        <Button
          type="button"
          onClick={onAddRankings}
          disabled={!canManage || addDisabled}
        >
          + Add / Edit rankings
        </Button>
      </div>
    </div>
  );
};

export default RankingsFilters;
